module.exports = __webpack_public_path__ + "static/map-10e10ded925671b8246ffacd63957e6f.png";